var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({staticClass:"inline-block fill-current",class:_vm.$style.icon,domProps:{"innerHTML":_vm._s(_vm.icon)}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }